import { type AlertDialogContextType, Page404 } from '@main/ui';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import React from 'react';

const TanStackRouterDevtools = import.meta.env.PROD
  ? () => null // Render nothing in production
  : React.lazy(() =>
      // Lazy load in development
      import('@tanstack/react-router-devtools').then((res) => ({
        default: res.TanStackRouterDevtools,
      })),
    );

type RouterContext = {
  dialog: AlertDialogContextType;
};

export const rootRoute = createRootRouteWithContext<RouterContext>()({
  notFoundComponent: Page404,
  component: () => {
    return (
      <>
        <Outlet />
        <TanStackRouterDevtools position="bottom-right" />
      </>
    );
  },
});
